import { useState } from 'react';
import { Button } from '@/shared/ui/Button';
import { FormField } from '@/shared/ui/FormField';
import { ApiError } from '@/shared/api/client';
import { passwordLogin } from './api';
import { PhoneField } from './PhoneField';
import type { LoginResponseLike } from '@/shared/auth/storage';

interface Props {
  onLoggedIn: (res: LoginResponseLike) => void;
}

export function PasswordStep({ onLoggedIn }: Props) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (!/^\d{8}$/.test(phone)) {
      setError('Утасны дугаар буруу (8 оронтой).');
      return;
    }
    if (password.length < 6) {
      setError('Нууц үг хэт богино байна.');
      return;
    }
    setBusy(true);
    try {
      const login = await passwordLogin(phone, password);
      onLoggedIn(login);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Утас эсвэл нууц үг буруу байна.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="auth-form" onSubmit={onSubmit}>
      <PhoneField value={phone} onChange={setPhone} name="pw-phone" autoFocus />
      <div style={{ position: 'relative' }}>
        <FormField
          label="Нууц үг"
          name="pw"
          type={show ? 'text' : 'password'}
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.currentTarget.value)}
          required
          style={{ paddingRight: 44 }}
        />
        <button
          type="button"
          className="ts-toggle-btn"
          style={{ position: 'absolute', right: 6, top: 25 }}
          onClick={() => setShow((x) => !x)}
          aria-label={show ? 'Нууц үгийг нуух' : 'Нууц үгийг харуулах'}
          title={show ? 'Нуух' : 'Харуулах'}
        >
          <i className={`bi ${show ? 'bi-eye-slash' : 'bi-eye'}`} />
        </button>
      </div>
      {error ? (
        <div className="auth-error" role="alert">
          <i className="bi bi-exclamation-circle" /> {error}
        </div>
      ) : null}
      <Button type="submit" className="auth-submit" disabled={busy} icon="box-arrow-in-right">
        {busy ? 'Нэвтэрч байна…' : 'Нэвтрэх'}
      </Button>
      <p className="if-hint" style={{ textAlign: 'center', margin: 0 }}>
        Нууц үг тохируулаагүй бол «SMS-ээр» нэвтэрч профайл хэсгээс тохируулна.
      </p>
    </form>
  );
}
